export default "__VITE_ASSET__CwEg89BA__"